import { LockOutlined } from "@ant-design/icons";
import { VzblIcon } from "../VzblIcon";
import { BuildingIcon } from "../BuildingIcon";
import { CSSProperties } from "react";
import { Tooltip } from "antd";

export enum VisibilityType {
  GLOBAL = "global",
  ORG = "org",
  PRIVATE = "private",
}

export const VisibilityIcon = (props: {
  visibility: VisibilityType;
  style?: CSSProperties;
  size?: number;
}) => {
  switch (props.visibility) {
    case VisibilityType.ORG: {
      return (
        <Tooltip title="Org - visible to all users in your organization">
          <span>
            {" "}
            {/* span is required to make tooltip work */}
            <BuildingIcon size={props.size} style={{ ...props.style }} />
          </span>
        </Tooltip>
      );
    }
    case VisibilityType.PRIVATE: {
      return (
        <Tooltip title="Private - visible only to you">
          <LockOutlined style={{ ...props.style, fontSize: props.size }} />
        </Tooltip>
      );
    }
    default: {
      return (
        <Tooltip title="Global - visible to all orgs and users">
          <span>
            {" "}
            {/* span is required to make tooltip work */}
            <VzblIcon size={props.size} style={{ ...props.style }} />
          </span>
        </Tooltip>
      );
    }
  }
};
